import * as Types from '@frameio/graphql-client/generated/types';

import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
import gql from 'graphql-tag';
import { FieldValueBase } from '../../../../utils/gql/generated/FieldValueBase';

import { useQuery, useLazyQuery, useMutation, useFragment, useSubscription } from '@apollo/client';
import type { QueryHookOptions, LazyQueryHookOptions, MutationHookOptions, SubscriptionHookOptions, UseFragmentOptions } from '@apollo/client';

export type NumberFieldValueFragment = { __typename?: 'AssetFieldValue', id: string, fieldType: Types.FieldTypeEnum, valueLength?: number | null, isValueTrimmed?: boolean | null, value: { __typename?: 'DateFieldValue' } | { __typename?: 'DerivedFieldValue' } | { __typename?: 'JsonFieldValue' } | { __typename?: 'LinkFieldValue' } | { __typename?: 'LongTextFieldValue' } | { __typename?: 'NumberFieldValue', number?: number | null } | { __typename?: 'RatingFieldValue' } | { __typename?: 'SelectFieldValue' } | { __typename?: 'SelectMultiFieldValue' } | { __typename?: 'TextFieldValue' } | { __typename?: 'ToggleFieldValue' } | { __typename?: 'UrlFieldValue' } | { __typename?: 'UserMultiFieldValue' } | { __typename?: 'UserSingleFieldValue' } | { __typename?: 'UsersFieldValue' }, fieldDefinition: { __typename?: 'ProjectFieldDefinition', id: string } };

export const NumberFieldValue = /*#__PURE__*/ gql`
    fragment NumberFieldValue on AssetFieldValue {
  ...FieldValueBase
  value {
    ... on NumberFieldValue {
      number
    }
  }
}
    ${FieldValueBase}` as unknown as DocumentNode<NumberFieldValueFragment, unknown>;

        

        
export const useNumberFieldValueFragment = (
  input: string | Omit<UseFragmentOptions<NumberFieldValueFragment, any>, 'fragment' | 'fragmentName'> | undefined | null
) => {
  const options = (() => {
    if (!input) return { from: null };
    if (typeof input === 'string') return { from: { id: input, __typename: 'AssetFieldValue' } };
    return input;
  })();

  return useFragment<NumberFieldValueFragment>({
    fragment: NumberFieldValue,
    fragmentName: 'NumberFieldValue',
    ...options,
  });
};
  
        